/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { isEmpty } from '@ember/utils';
import moment from 'moment-timezone';
import { DEFAULT_FORMAT } from 'cio/utils/broadcasts';
import ExportsService from 'cio/services/exports';
import NewsletterModel from 'cio/models/newsletter';

interface ExportButtonArgs {
  newsletters: NewsletterModel[];
  search: string;
  startTime?: string;
  endTime?: string;
  channel: string;
}

export default class ExportButton extends Component<ExportButtonArgs> {
  @service exports!: ExportsService;

  get allSent() {
    return !isEmpty(this.args.newsletters) && this.args.newsletters.isEvery('isSent');
  }

  @action
  createExport() {
    let { search, startTime, endTime, channel } = this.args;

    return this.exports.newsletterDeliveryTotals({
      from: 'newsletters_list',
      search: isEmpty(search) ? undefined : search,
      startTime: startTime != null ? moment(startTime, DEFAULT_FORMAT).startOf('day').unix() : undefined,
      endTime: endTime != null ? moment(endTime, DEFAULT_FORMAT).endOf('day').unix() : undefined,
      channel,
    });
  }
}
